require("!!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/script-loader/addScript.js")(require("!!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/raw-loader/index.js!/home/login/Documents/Jijifest/A4TCorev2AdminUi/node_modules/jquery-slimscroll/jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-slimscroll/jquery.slimscroll.js
// module id = 591
// module chunks = 11